var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTransactionSubmitted = function SvgTransactionSubmitted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3012 11.2084C24.5915 11.4729 24.6124 11.9227 24.3479 12.213L15.7434 21.657L10.1598 15.9834C9.88436 15.7035 9.88797 15.2532 10.1679 14.9778C10.4478 14.7023 10.898 14.7059 11.1735 14.9858L15.7036 19.5889L23.2966 11.2551C23.5611 10.9648 24.0109 10.9439 24.3012 11.2084Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30.5778C24.0511 30.5778 30.5778 24.0511 30.5778 16C30.5778 7.94892 24.0511 1.42222 16 1.42222C7.94892 1.42222 1.42222 7.94892 1.42222 16C1.42222 24.0511 7.94892 30.5778 16 30.5778ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4.97691C9.91258 4.97691 4.97776 9.91173 4.97776 15.9991C4.97776 22.0865 9.91258 27.0214 16 27.0214C22.0874 27.0214 27.0222 22.0865 27.0222 15.9991C27.0222 15.6064 27.3406 15.288 27.7333 15.288C28.1261 15.288 28.4444 15.6064 28.4444 15.9991C28.4444 22.872 22.8729 28.4436 16 28.4436C9.12711 28.4436 3.55554 22.872 3.55554 15.9991C3.55554 9.12625 9.12711 3.55469 16 3.55469C16.3927 3.55469 16.7111 3.87306 16.7111 4.2658C16.7111 4.65853 16.3927 4.97691 16 4.97691Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransactionSubmitted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transaction_submitted.3c29caf6.svg";
export { ForwardRef as ReactComponent };